import { styled } from '@mui/system';
import { Box, Button, Typography, Avatar, IconButton, ListItem, DialogTitle } from '@mui/material';

export const ShiftInformationContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  height: 'calc(100vh - 187px)',
  gap: theme.spacing(2),
}));

export const AssignedButton = styled(Button)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: theme.spacing(1.5),
  backgroundColor: '#1C1C1E',
  borderRadius: theme.spacing(1),
  cursor: 'pointer',
  '&:disabled': {
    cursor: 'not-allowed',
  },
}));

export const AvatarStyled = styled(Avatar)(({ theme }) => ({
  width: '40px',
  height: '40px',
  borderRadius: '50%',
  marginRight: theme.spacing(1),
}));

export const Notes = styled(Box)(({ theme }) => ({
  backgroundColor: '#1C1C1E',
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(1),
  color: 'white',
}));

export const ButtonRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  paddingBottom: theme.spacing(2),
  justifyContent: 'space-between',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const ActionButton = styled(Button)(({ theme, variant }) => ({
  flex: 1,
  backgroundColor: theme.palette.primary,
  border: 'none',
  fontSize: '17px',
  color: variant === 'cancel' ? theme.colors.red : theme.palette.text.primary,
  fontWeight: 400,
  lineHeight: '22px',
  letterSpacing: '-0.4px',
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(1),
  cursor: 'pointer',
  textAlign: 'center',
  '&:disabled': {
    cursor: 'not-allowed',
    pointerEvents: 'none',
    backgroundColor: theme.palette.primary,
    color: variant === 'cancel' ? theme.colors.red : theme.palette.text.primary,
    opacity: 0.5,
  },
}));

export const InfoText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const DateText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.info,
}));

export const ShiftNotesTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.primary,
}));

export const ShiftsContainer = styled(Box)(({ theme }) => ({
  borderRadius: theme.spacing(1.5),
  padding: `${theme.spacing(1)} ${theme.spacing(1)}`,
  background: theme.palette.background.secondary,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const ShiftInfoBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

export const RoleSelection = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  justifyContent: 'space-between',
  gap: theme.spacing(2),
}));

export const StyledTitle = styled(DialogTitle)(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  gap: theme.spacing(2),
}));
